module.exports = __webpack_public_path__ + "static/media/contact.1f447e4b.jpg";